define('score_bootstrap/Models/SitecoreId',['loglevel'], function (log) {
    "use strict";

    var re = /^\{?[A-Za-z\d]{8}-(?:[A-Za-z\d]{4}-){3}[A-Za-z\d]{12}\}?$/;

    function normalize(id) {
        // TODO: need unit tests
        id = id.toLowerCase();
        return id.replace("{", "").replace("}", "");
    }

    function SitecoreId(id) {
        var raw = String(id);
        if (re.test(raw) === false) {
            throw new RangeError("Invalid Sitecore ID string.");
        }

        Object.defineProperty(this, "guid", { value: normalize(raw), enumerable: true });
    }

    SitecoreId.prototype.toString = function () {
        return this.guid;
    };

    SitecoreId.prototype.equals = function (other) {
        return !!(other) && other.isSitecoreId === true && other.guid === this.guid;
    };

    Object.defineProperty(SitecoreId.prototype, "isSitecoreId", {
        enumerable: false,
        value: true
    });

    SitecoreId.parse = function (value) {
        if (!value) {
            return null;
        }

        if (value.isSitecoreId === true) {
            return value;
        }

        try {
            return new SitecoreId(value);
        }
        catch (e) {
            log.error(e);
            return null;
        }
    };

    SitecoreId.RegEx = re;
    SitecoreId.RegExGlobal = /\{?[A-Za-z\d]{8}-(?:[A-Za-z\d]{4}-){3}[A-Za-z\d]{12}\}?/g;

    return SitecoreId;
});
